import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { Text } from '@/components/common/text';

export const PaymentMethodCardBody: React.FC<{
  cardType: { name: string; icon: React.ReactNode; isBank: boolean } | null;
  method: any;
  isOnlyCard?: boolean;
  formattedExpiry?: string;
}> = ({ cardType, method, isOnlyCard, formattedExpiry }) => {
  const last4Prefix = isOnlyCard ? '**** **** **** ' : '*';
  return (
    <View style={styles.cardFooter}>
      {isOnlyCard && (
        <View style={styles.cardLabels}>
          <Text style={styles.cardTypeLabel}>{cardType?.name || 'Card'}</Text>
          <Text style={styles.cardExpiryLabel}>Expiry</Text>
        </View>
      )}
      <View style={styles.cardDetails}>
        {cardType?.isBank ? (
          <Text style={[styles.cardAccountName, isOnlyCard && styles.cardAccountNameLarge]} numberOfLines={2}>
            {method.name || 'Bank Account'}
          </Text>
        ) : (
          <>
            <Text style={[styles.cardNumber, isOnlyCard && styles.cardNumberLarge]}>
              {last4Prefix}{method.last4}
            </Text>
            <Text style={[styles.cardExpiry, isOnlyCard && styles.cardExpiryLarge]}>
              {formattedExpiry}
            </Text>
          </>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  cardFooter: {
    justifyContent: 'flex-end',
  },
  cardLabels: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 4,
  },
  cardTypeLabel: {
    fontSize: 16,
    fontWeight: '400',
    color: 'white',
  },
  cardExpiryLabel: {
    fontSize: 16,
    fontWeight: '400',
    color: 'white',
    textAlign: 'right',
  },
  cardDetails: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  cardNumber: {
    fontSize: 14,
    fontWeight: '400',
    color: 'white',
  },
  cardNumberLarge: {
    fontSize: 18,
    fontWeight: '600',
  },
  cardExpiry: {
    fontSize: 14,
    fontWeight: '400',
    color: 'white',
    textAlign: 'right',
  },
  cardExpiryLarge: {
    fontSize: 18,
    fontWeight: '600',
  },
  cardAccountName: {
    fontSize: 14,
    fontWeight: '400',
    color: 'white',
    flex: 1,
  },
  cardAccountNameLarge: {
    fontSize: 18,
    fontWeight: '600',
  },
});

export default PaymentMethodCardBody;


